import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, HttpRequestModel } from 'src/app/service/httpservice/http.service';
import { buildQueryString } from 'src/app/utils/functions';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();
  constructor(private httpService: HttpService) { }

  delete = {
    models: (id: number): Observable<any> => this.request('DELETE', `media/${id}`),
    employees: (id: number): Observable<any> => this.request('DELETE', `media/${id}`),
    tools: (id: number): Observable<any> => this.request('DELETE', `media/${id}`),
    potential_jobs: (id: number): Observable<any> => this.request('DELETE', `media/${id}`),
  };

  create = {
    models: (data): Observable<any> => this.formRequest('POST', `media/`, data),
    employees: (data): Observable<any> => this.formRequest('POST', `media/`, data),
    tools: (data): Observable<any> => this.formRequest('POST', `media/`, data),
    potential_jobs: (data): Observable<any> => this.formRequest('POST', `media/`, data),
  };

  private request(
    requestType: string,
    url: string,
    data: any = '',
    showLoader: boolean = false,
    hideLoader: boolean = false,
  ): Observable<any> {
    if (requestType === 'GET' && data) {
      const queryString = buildQueryString(data);
      url += queryString;
      data = '';
    }

    this.HttpRequestModel.reset();
    this.HttpRequestModel.method = requestType;
    this.HttpRequestModel.url = url;
    this.HttpRequestModel.body = data;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  private formRequest(
    requestType: string,
    url: string,
    data: any = '',
    showLoader: boolean = false,
    hideLoader: boolean = false,
  ): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.method = requestType;
    this.HttpRequestModel.url = url;
    this.HttpRequestModel.formType = 'multipart';
    this.HttpRequestModel.body = data;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
